export const array_skeletons = new Array(3).fill('');
